import { Base } from '.';

export class Roles extends Base {
  read = async () => {
    const result = await this.apiClient.get('/role');

    return result;
  };

  create = async (data) => {
    await this.apiClient.post('/role', { body: { ...data } });
  };

  update = async (data) => {
    await this.apiClient.put('/role', { body: { ...data } });
  };

  delete = async ({ id }) => {
    await this.apiClient.delete(`/role/${id}`);
  };
}
